import React from 'react';

import OpterraPhoenixLogo from 'assets/images/OpterraPhoenixLogo.png';
import Notification from 'components/common/Notification';
import {
  CmdKey,
  ShortcutKey,
} from 'components/common/ShortcutHint/ShortcutHint';
import { useCtrlWheelZoomPrevention } from 'hooks/useCtrlWheelZoomPrevention';

interface MultiSelectHintProps {
  className?: string;
  /**
   * When false the hint text is hidden but the component stays mounted so
   * zoom-prevention effects keep running while the picker is open.
   * Defaults to true.
   */
  visible?: boolean;
  /**
   * Suppress Ctrl+Scroll browser page zoom while this component is mounted,
   * forwarding the scroll delta to the nearest scrollable ancestor instead.
   * Defaults to false.
   */
  preventZoom?: boolean;
}

const MultiSelectHint: React.FC<MultiSelectHintProps> = ({
  className,
  visible = true,
  preventZoom = false,
}) => {
  useCtrlWheelZoomPrevention(preventZoom);

  if (!visible) return null;

  return (
    <Notification
      type="primary"
      closable={false}
      className={className}
      icon={
        <img
          src={OpterraPhoenixLogo}
          alt="Logo"
          className="mt-1 h-4 w-auto brightness-0 invert"
        />
      }
    >
      <span className="text-sm">
        Hold <ShortcutKey variant="light">Ctrl</ShortcutKey> /{' '}
        <ShortcutKey variant="light">
          <CmdKey />
        </ShortcutKey>{' '}
        to select multiple items.
      </span>
    </Notification>
  );
};

export default MultiSelectHint;
